import { apiFetch, apiPost, apiPut, apiDelete } from '@/lib/api-client';

export async function getServices() {
  try {
    return await apiFetch<any[]>('/api/services');
  } catch {
    return [];
  }
}

export async function getServiceById(id: string) {
  try {
    return await apiFetch<any>(`/api/services/${id}`);
  } catch {
    return null;
  }
}

export async function createService(data: any) {
  return apiPost('/api/services', data);
}

export async function updateService(id: string, data: any) {
  return apiPut(`/api/services/${id}`, data);
}

export async function deleteService(id: string) {
  return apiDelete(`/api/services/${id}`);
}

export async function getServiceBySlug(slug: string) {
  try {
    return await apiFetch<any>(`/api/public/services/slug/${encodeURIComponent(slug)}`);
  } catch {
    return null;
  }
}

export async function getServicesPageData() {
  try {
    return await apiFetch<any[]>('/api/public/services/page');
  } catch {
    return [];
  }
}
